import React from 'react';

import FieldSelect from '../commons/FieldSelect';
import FieldNumber from '../commons/FieldNumber';

const SecurityCard = () => {
  const currentYear = (new Date()).getFullYear();

  const expiracyYearsList = [...Array(10).keys()].map((element, index) => (
    { value: (currentYear + index) - 2000 }
  ));

  const months = [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
  ].map((item) => ({ value: item }));

  return (
    <div className="field">
      <label htmlFor="securityCard">
        Fecha de vencimiento
        <span className="color-red">&nbsp;*</span>
      </label>
      <div className="field card-security-data">
        <FieldSelect
          name="cardExpirationMonth"
          placeholder="Mes"
          list={months}
          classInvalid="field-invalid-small"
          className="card-data-input"
          required />
        <div className="slash"> / </div>
        <FieldSelect
          name="cardExpirationYear"
          classInvalid="field-invalid-small"
          className="card-data-input"
          placeholder="Año"
          list={expiracyYearsList}
          required />
        <FieldNumber
          name="cardCVV"
          classInvalid="field-invalid-small"
          className="card-data-input"
          type="password"
          placeholder="CVV"
          required
          maxLength={4} />
      </div>
    </div>
  );
};

export default SecurityCard;
